module.exports = __webpack_public_path__ + "static/media/time-session-6h.0b873328.svg";